import type { JSX } from 'react';
import { usePropertySelection } from '@/components/dashboard/properties';

export interface PropertyBulkActionsBarProps {
  pagination?: {
    page: number;
    totalPages: number;
    totalItems: number;
    pageSize: number;
  };
}

export function PropertyBulkActionsBar({
  pagination,
}: PropertyBulkActionsBarProps): JSX.Element | null {
  const selection = usePropertySelection();

  if (selection.selectedCount === 0) {
    return null;
  }

  const multiPageHelper =
    pagination && pagination.totalPages > 1
      ? `Page ${String(pagination.page)} of ${String(
          pagination.totalPages,
        )}. Bulk actions apply only to the ${selection.selectedCount.toString()} selected properties on this page.`
      : null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-3xl border border-surface-subtle bg-white px-4 py-3 shadow-sm">
      <div className="flex flex-col">
        <p className="text-sm font-semibold text-text-primary">
          {selection.selectedCount} selected
        </p>
        {multiPageHelper !== null ? (
          <p className="text-xs text-text-primary/70">{multiPageHelper}</p>
        ) : null}
        <p className="text-xs text-text-primary/70">
          Bulk edits are disabled. Update details from each property&apos;s edit page.
        </p>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <button
          type="button"
          className="text-sm font-semibold text-text-primary/70 transition hover:text-text-primary"
          onClick={() => {
            selection.clearSelection();
          }}
        >
          Clear
        </button>
      </div>
    </div>
  );
}
